import React, { useState } from 'react';
import { Button, Result, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/global-background.css';
import '../styles/RewardsPage.css';

import AvatarBadge, { modalStyle } from '../components/AvatarBadge';

const RewardsPage: React.FC = () => {
  const [language, setLanguage] = useState<'en' | 'zh'>('zh');
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="nova-container">
      <div className="nova-grid"></div>

      <Navbar language={language} />

      <div className="content">
        <div className="title-section">
          <h1 className="nova-title">
            {language === 'en' ? 'Rewards' : '活动'}
          </h1>
          <p className="nova-subtitle">
            {language === 'en'
              ? 'Earn rewards for participating in our ecosystem'
              : '参与我们的生态活动并获得奖励'}
          </p>
        </div>

        <div className="rewards-content">
          {/* ➤ 新活动：币圈大乱斗主播赛竞猜 */}
          <Result
            status="warning"
            icon={<span className="coming-soon-icon">🏆</span>}
            title={
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <span className="coming-soon-title">
                  {language === 'en'
                    ? 'Crypto Battle Royale Prediction'
                    : '币圈大乱斗主播赛竞猜'}
                </span>
                <span style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-30px',
                  background: 'linear-gradient(45deg, #ff6b6b, #ff8e8e)',
                  color: 'white',
                  fontSize: '10px',
                  padding: '2px 6px',
                  borderRadius: '8px',
                  fontWeight: 'bold',
                  boxShadow: '0 2px 4px rgba(255, 107, 107, 0.3)'
                }}>
                  NEW
                </span>
              </div>
            }
            subTitle={
              <div className="coming-soon-subtitle">
                <p style={{ margin: '8px 0', fontSize: '14px', lineHeight: '1.5' }}>
                  {language === 'en'
                    ? 'Predict daily champions in our 3-day tournament! Stake 44,444 NClab tokens to participate and win amazing rewards!'
                    : '参与为期3天的主播赛事竞猜！质押44,444枚NClab代币预测每日冠军，赢取丰厚奖励！'}
                </p>
                <div style={{ 
                  background: 'rgba(255, 193, 7, 0.1)', 
                  border: '1px solid rgba(255, 193, 7, 0.3)',
                  borderRadius: '6px',
                  padding: '8px 12px',
                  margin: '12px 0',
                  fontSize: '12px'
                }}>
                  <strong>🎯 {language === 'en' ? 'How to Play:' : '参与方式:'}</strong><br/>
                  {language === 'en' 
                    ? '• Daily predictions for 3 days • Stake 44,444 NClab per prediction • Win rewards for correct predictions'
                    : '• 连续3天每日预测 • 每次预测质押44,444 NClab • 预测正确获得奖励'}
                </div>
              </div>
            }
            extra={[
              <Button
                type="primary"
                key="participate"
                className="rewards-button"
                style={{
                  background: 'linear-gradient(45deg, #ff6b6b, #ff8e8e)',
                  border: 'none',
                  boxShadow: '0 4px 12px rgba(255, 107, 107, 0.3)',
                  fontSize: '16px',
                  height: '44px',
                  padding: '0 24px'
                }}
                onClick={() => navigate('/battle-prediction')}
              >
                {language === 'en' ? '🚀 Join Battle' : '🚀 立即参与'}
              </Button>,
              <Button
                key="rules"
                className="rewards-button"
                style={{ marginLeft: '12px' }}
                onClick={() => navigate('/post/gameme-lab2')}
              >
                {language === 'en' ? '📋 Rules' : '📋 活动规则'}
              </Button>,
            ]}
          />
          <br />

          {/* ➤ 空投活动：换推特头像领取空投 */}
          <Result
            status="success"
            /* ⚠️ 这里改回 coming-soon-icon，沿用旧样式 */
            icon={<span className="coming-soon-icon">🪂</span>}
            title={
              /* 同理，保持 coming-soon-title */
              <span className="coming-soon-title">
                {language === 'en'
                  ? 'Airdrop: Change Your Twitter Avatar'
                  : '更换头像加入我们的社区'}
              </span>
            }
            subTitle={
              <span className="coming-soon-subtitle">
                {language === 'en'
                  ? 'Use our avatar generator to create a new Twitter profile picture and claim exclusive tokens.'
                  : '立即设计您的Twitter头像'}
              </span>
            }
            extra={[
              <Button
                type="primary"
                key="generate"
                className="rewards-button"
                onClick={() => setShowModal(true)}
              >
                {language === 'en' ? 'Generate Avatar' : '生成专属头像并更换'}
              </Button>,
            ]}
          />
          <br />
          <Result
            status="info"
            icon={<span className="coming-soon-icon">🎁</span>}
            title={<span className="coming-soon-title">
              {language === 'en' ? 'Coming Soon' : '即将推出'}
            </span>}
            subTitle={<span className="coming-soon-subtitle">
              {language === 'en'
                ? 'We are working hard to bring you exciting rewards and incentives. Stay tuned!'
                : '我们正在努力为您带来激动人心的奖励和激励措施。敬请期待！'}
            </span>}
            extra={[
              <Button
                type="primary"
                key="homepage"
                className="rewards-button"
                onClick={() => navigate('/')}
              >
                {language === 'en' ? 'Back to Home' : '返回首页'}
              </Button>,
              <Button
                key="products"
                className="rewards-button"
                onClick={() => navigate('/products')}
              >
                {language === 'en' ? 'Explore Products' : '探索产品'}
              </Button>,
            ]}
          />

          {showModal && (
            <div style={modalStyle.overlay} onClick={() => setShowModal(false)}>
              <div
                style={modalStyle.box}
                onClick={(e) => e.stopPropagation()} /* 阻止冒泡关闭 */
              >
                <button style={modalStyle.close} onClick={() => setShowModal(false)}>
                  ✕
                </button>
                <AvatarBadge />
              </div>
            </div>
          )}

        </div>

        <Footer language={language} setLanguage={setLanguage} />
      </div>
    </div>
  );
};

export default RewardsPage; 